import { useMutation } from '@apollo/client/react'
import * as Sentry from '@sentry/react'
import { toast } from 'sonner'
import {
  PORTAL_UPDATE_ORG_MEMBER_ROLE,
  type PortalUpdateOrgMemberRoleData,
  type PortalUpdateOrgMemberRoleVars,
} from '../api/operations'
import type { AssignableRole } from '../constants/assignableRoles'

export function useUpdateOrgMemberRole(options?: { onSuccess?: () => void }) {
  const [mutate, { loading, error }] = useMutation<
    PortalUpdateOrgMemberRoleData,
    PortalUpdateOrgMemberRoleVars
  >(PORTAL_UPDATE_ORG_MEMBER_ROLE, {
    // Por NOMBRE: refresca todas las páginas activas del listado, sin acoplarse
    // a un juego fijo de variables take/skip.
    refetchQueries: ['PortalListOrgMembers'],
    awaitRefetchQueries: true,
    onError: (err) => {
      Sentry.captureException(err, {
        tags: { operation: 'PortalUpdateOrgMemberRole' },
      })
      toast.error('No se pudo cambiar el rol', {
        description: err.message,
      })
    },
  })

  /**
   * `newRole: null` = QUITAR el rol (goal portal-roles-2): el miembro conserva
   * la membresía pero la matriz de roles le cierra los datos.
   */
  const updateRole = async ({
    memberId,
    newRole,
  }: {
    memberId: string
    newRole: AssignableRole | null
  }) => {
    const result = await mutate({ variables: { input: { memberId, newRole } } })
    if (result.data?.portalUpdateOrgMemberRole) {
      toast.success(newRole ? 'Rol actualizado' : 'Rol retirado')
      options?.onSuccess?.()
    }
    return result.data?.portalUpdateOrgMemberRole ?? null
  }

  return { updateRole, loading, error }
}
